import { render, staticRenderFns } from "./providerJoin.vue?vue&type=template&id=72e82350&"
import script from "./providerJoin.vue?vue&type=script&lang=js&"
export * from "./providerJoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports